<script lang="ts">
  import type { ProductLinePriceQuote } from "@shared/types/ProductLine";
  import FormatMoney from "@shared/svelte/Components/FormatMoney.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  export let priceQuotes: ProductLinePriceQuote[];

</script>

<div data-testid="sell-sheet-buy-price-quotes">
  <div class="fizz-tooltip-container fizz-stack-4">
    <button
      class="fizz-tooltip-trigger fizz-flex-row-4"
      aria-describedby="price-quotes-tooltip"
      style="color: black;"
    >
      <span class="fizz-text-medium fizz-text-strong"> Rep's Price Quotes </span>
      <Icon type={"Info"} extraClassNames={"fizz-icon-12"} />
    </button>
    <div
      class="fizz-tooltip fizz-tooltip fizz-tooltip-top"
      role="tooltip"
      id="price-quotes-tooltip"
    >
      Price quotes will apply at the discretion of your sales rep on your final invoice and will not
      apply to your cart total.
    </div>
  </div>
  {#each priceQuotes as priceQuote}
    <div>
      <span class="fizz-text-medium fizz-text-strong">
        {`${priceQuote.label} `}
      </span>
      {#if priceQuote.price_per_unit}
        <span class="fizz-text-medium">
          {"- "}
          <FormatMoney input={priceQuote.price_per_unit} />/{priceQuote.container_type}
          {" "}
        </span>
      {/if}
      {#if priceQuote.price_per_case}
        <span class="fizz-text-medium">
          {"- "}
          <FormatMoney input={priceQuote.price_per_case} />/case
        </span>
      {/if}
    </div>
  {/each}
</div>
